export const deleteTestHard = (payload?: any) => ({
    type: "@saga/DELETE_TEST_HARD",
    payload
});

